import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userOrder: "",
  discountResponse: "",
  allOrder: "",
  isLoading: false,
  isLoadings: false,
  address:{},
  orderDetails:{},
  oderdetailLoading:false
};

const createOrder = createSlice({
  name: "createOrder",
  initialState,
  reducers: {
    // create order 
    userCreateOrderRequest: (state) => {
      state.isLoading = true; // Set isLoading to true when  request starts
    },

    userCreateOrderSuccess: (state, action) => {
      state.userOrder = action.payload;
      state.isLoading = false;
    },

    userCreateOrderFailure: (state) => {
      state.isLoading = false; // Set isLoading to true when  request starts
    },

    items_coupon_discount_Request: (state) => {
      state.isLoadings = true; // Set isLoading to true when  request starts
    },

    items_coupon_discount_Success: (state, action) => {
      state.discountResponse = action.payload;
      state.isLoadings= false;
    },

    items_coupon_discount_Failure: (state) => {
      state.isLoadings = false; // Set isLoading to true when  request starts
    },

    user_all_order: (state, action) => {
      state.allOrder = action.payload; 
    },
    user_order_detail: (state, action) => {
      state.orderDetails = action.payload; 
    },
    address: (state, action) => {
      state.address = action.payload; 
    },
    oderdetailLoading: (state, action) => {
      state.oderdetailLoading = action.payload;
    },
  },
});

export const {
  userCreateOrderRequest,
  userCreateOrderSuccess,
  userCreateOrderFailure,
  items_coupon_discount_Request,
  items_coupon_discount_Success,
  items_coupon_discount_Failure,
  user_all_order,
  user_order_detail,
  address,
  oderdetailLoading
} = createOrder.actions;

export default createOrder.reducer;
